import { createReducer, on } from '@ngrx/store';
import { DefaultLookupState } from '../../models/states/default-lookup-state.interfaces';
import * as fromDefaultLookupActions from '../actions/default-lookup.actions';

export const DefaultLookupStateKey = 'defaultLookup';

const initialState: DefaultLookupState = {
  isReadyOnLanding: false,
  isError: false,
  triggerDefaultsLookupLanding: false,
  cacheKeySuffix: '',
  defaultLookupLandingData: null
};

export const defaultLookupReducer = createReducer(
  initialState,
  on(
    fromDefaultLookupActions.StoreDefaultLookupInputValues,
    (
      state,
      { cacheKeySuffix, triggerDefaultsLookupLanding, defaultLookupResponse }
    ) => ({
      ...state,
      cacheKeySuffix,
      triggerDefaultsLookupLanding,
      defaultLookupLandingData: state.isReadyOnLanding
        ? state.defaultLookupLandingData
        : defaultLookupResponse
    })
  ),
  on(
    fromDefaultLookupActions.LoadDefaultLookupLandingSuccess, //this is used on modify page
    (state, { defaultLookupLandingData }) => ({
      ...state,
      isReadyOnLanding: true,
      isError: false,
      defaultLookupLandingData
    })
  ),
  on(fromDefaultLookupActions.LoadDefaultLookupLandingFailure, (state) => ({
    ...state,
    isReadyOnLanding: false,
    isError: true
  }))
);
